import { render } from "./CategoriesComponent.vue?vue&type=template&id=0ebedb1e"
import script from "./CategoriesComponent.vue?vue&type=script&lang=js"
export * from "./CategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__